
export function remove(arr, index = -1, object = null) {
  return arr.filter(function (ele, idx) {
    return (index < 0 || idx !== index) && (!object || object !== index);
  });
}

export function exclude(arr, prop) {
  return arr.map(({ [prop]: _, ...rest }) => rest);
};